// Single source of truth for the product-category → group mapping.
// Mirrors the "Products" mega-menu grouping in
// src/components/header/ModernHeader.js. Used for breadcrumbs so the product
// detail + catalog listing pages can show "Products > Hardware > Computer Systems".

export const CATEGORY_GROUPS = {
    Hardware: ['Computer Systems', 'Displays', 'Network Devices', 'Accessories'],
    Solutions: ['Software & Subscriptions', 'Storage Devices', 'Power & Rack Equipment', 'Input & Output Devices']
};

// Reverse lookup: category name -> group name ('Hardware' | 'Solutions')
const CATEGORY_TO_GROUP = Object.entries(CATEGORY_GROUPS).reduce((map, [group, cats]) => {
    cats.forEach(cat => { map[cat] = group; });
    return map;
}, {});

/**
 * Group ('Hardware' | 'Solutions') a category belongs to, or null if unknown.
 * @param {string} category
 * @returns {string|null}
 */
export function getCategoryGroup(category) {
    return CATEGORY_TO_GROUP[category] || null;
}

/**
 * Catalog listing route filtered to a category. Encodes the value so category
 * names containing '&' (e.g. "Software & Subscriptions") route correctly.
 * @param {string} category
 * @returns {string}
 */
export function categoryPath(category) {
    return `/accessories?category=${encodeURIComponent(category)}`;
}
